import * as types from "../actions/visitorTypes";

  const initialState = {
    data: [],
    loading: false,
    error: null,
  };

  const visitorReducer = (state = initialState, action, updatedVisitor) => {
    switch (action.type) {
        case types.FETCH_VISITOR_REQUEST:
        case types.ADD_VISITOR_REQUEST:
            ////console.log(action.payload)
            return { 
                ...state,
                loading: true,
                error: null 
            };

            //for fetching visitors
        case types.FETCH_VISITOR_SUCCESS:
            ////console.log(action.payload)
            return { 
                ...state, 
                loading: false,
                data: action.payload.visitors 
            };

              //FOR ADDING visitors
              case types.ADD_VISITOR_SUCCESS: 
              ////console.log('ADDED data:', [...state.data, action.payload]); 
                  return {
                    ...state,
                    loading: false,
                    data: action.payload,
                  };


                   //FOR UPDATING SITES      
            case types.UPDATE_VISITOR_REQUEST:
                ////console.log(action.payload)
                return {
                  ...state,
                  loading: true,
                  payload: updatedVisitor,
                  
                };
         
              case types.UPDATE_VISITOR_SUCCESS:
                ////console.log("Before state update", state); 
                ////console.log("UPDATED VISITOR" , action.payload);
                return {
                  ...state,
                  loading: false,
                  data: state.data.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                  ),
                };

                          //FOR DELETING SITES 
                          case types.DELETE_VISITOR_REQUEST:
                            ////console.log(action.payload)
                            return { 
                                ...state,
                                loading: true,
                                // payload: action.payload 
                            };
            
                        case types.DELETE_VISITOR_SUCCESS:
                          ////console.log("reducer delete VISITOR", action.payload)
                            ////console.log(action.payload);
                            return {
                              ...state,
                              loading: false,
                              data: state.data.filter((item) => item.id === action.payload.visitorid ? item.timeout = action.payload.timeout : item),
                            };

            
      case types.FETCH_VISITOR_FAILURE:
      case types.ADD_VISITOR_FAILURE:
        case types.UPDATE_VISITOR_FAILURE:
        case types.DELETE_VISITOR_FAILURE:
         return {
            ...state,
            loading: false,
            error: action.payload,
          };
        default:
          return state;
      }
    };
  
    export default visitorReducer;
  
